exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cipideatable-cssmodule-cipideatable-component-1hryR{border:1px solid red}.cipideatable-cssmodule-table-container-nKX3A{min-height:500px}", ""]);

// exports
exports.locals = {
	"cipideatable-component": "cipideatable-cssmodule-cipideatable-component-1hryR",
	"table-container": "cipideatable-cssmodule-table-container-nKX3A"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/BrowseIdeas/cipideatable.cssmodule.scss
// module id = 598
// module chunks = 0